<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-07-28 14:43:45
--> 
<template>
  <div>
    <connect></connect>
  </div>
</template> 
 
<script>
import connect from './connect'
export default {
  components: {
    connect
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>